<template>
  <div class="wxOpen setHeightFullWhite">
    <div class="wxOpenSon">
      <div
        class="wxOpenSonImg "
        style="width:80px;height: 80px;margin: 20px auto;"
      >
        <img
          :src="information"
          mode=""
          style="width: 100%;height: 100%;"
        ></img>
      </div>
      <div
        style="text-align: center;"
        class="text-center padding-xl"
      >请在微信客户端打开链接</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      information: this.$mAssetsPath.information,
    }
  },
  methods: {},
}
</script>

<style>
</style>
